<template>
  <div :class="$style.cardList">
    <div :class="$style.card" :key="index" v-for="(item, index) in directionList">
      <div :class="$style.title" :style="{background: item.titleBg}">{{ item.title }}</div>
      <div :class="$style.intro" v-html="item.intro"></div>
    </div>
  </div>
</template>

<script>
import { directionList } from './data'

export default {
  data () {
    return {
      directionList
    }
  }
}
</script>

<style lang="scss" module>
.card {
  position: absolute;
  width: 450px;
  background: #FFFFFF;
  box-shadow: 0px 2px 20px 0px rgba(151,151,194,0.13);
  border-radius: 12px;
  overflow: hidden;

  &:first-child {
    top: 145px;
    left: 1px;
  }

  &:nth-child(2) {
    top: 214px;
    right: -1px;
  }

  &:last-child {
    bottom: 60px;
    left: 231px;
  }
}

.title {
  box-sizing: border-box;
  padding-left: 35px;
  padding-top: 16px;
  height: 56px;
  font-size: 18px;
  font-weight: 500;
  color: #fff;
  line-height: 25px;
}

.intro {
  padding: 22px 35px;
  font-size: 15px;
  font-weight: 400;
  color: #404040;
  line-height: 28px;

  strong {
    font-weight: 500;
  }
}
</style>
